import "./__content.scss"; import "./__form.scss"; import "./__header.scss"; import "./__more_text.scss"; import "./__thumbnails.scss"; import "./__title.scss"; import "./featured_publication_module.scss"
import "./__content.coffee"; import "./__form.coffee"; import "./featured_publication_module.coffee"
